import React from "react";
import ReactDOM from "react-dom";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
export default class Sendgiftermodal extends React.Component {
    constructor(props) {
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event){
        if(event.keyCode === 27) {
         this.onToggle();
        }
      }
      componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
      }
      componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
      }

    onToggle = () => {
        let createGiftModalElement = document.querySelector('#createGiftModal');
        ReactDOM.unmountComponentAtNode(createGiftModalElement);
    }

    render() {
        let _urls = `${BASE.url}`;
        const action = `${BASE.url}`+'landing/buy-abroad';
        return (
            <div className='App'>
                <div className="content">
                    <div id="infoModal" className="modal_v4">
                        <div className="modalHeader">
                           {modalV4.gift_title}
                    </div>
                        <div className="modalBody">
                            <form action={ action } method="POST">
                                <div className="form-group">
                                <label className="input-field-hint">* {modalV4.phone_whatsapp}</label>
                                    <IntlTelInput
                                        defaultCountry="sd"
                                        containerClassName="intl-tel-input"
                                        inputClassName="form-control"
                                        className="input"
                                        fieldName="phone"
                                    />
                                    <input type="hidden" name="redirection" value={_urls}/>
                                    <input type="hidden" name="advert_number[]" value={this.props.advert_id}/>
                                    <input type="hidden" name="advert_id" value={this.props.advert_id}/>
                                </div> 
                                <label className="input-field-hint">{modalV4.allrequired}</label>
                                <div className="modalFooter">
                                    <button className="btn primary-1-btn"> {modalV4.sendgift} </button>
                                    <a className="close" onClick={this.onToggle}>{modalV4.close}</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}